class FullWidthImage extends HTMLElement {
  constructor() {
    super();
    this.intervalTime = 2500;
    this.images = null;
    this.currentImage = 1;
    this.lastImage = false;
    this.intervalId = null;
  }

  connectedCallback() {
    this.intervalTime = this.getAttribute('data-interval')
      ? Number(this.getAttribute('data-interval'))
      : 2500;
    this.images = this.querySelectorAll('[data-full-width-image-images]');
    this.currentImage = 1;
    this.lastImage = false;

    // add the code for the section including internal functions
    if (this.images.length <= 1) return;

    this.intervalId = setInterval(() => {
      this.images.forEach((img) => {
        const dataIndex = img.getAttribute('data-index');
        const dataLastItem = img.getAttribute('data-last-item') !== null;
        if (this.currentImage === Number(dataIndex)) {
          img.classList.add('opacity-100');
          img.classList.remove('opacity-0');
          this.lastImage = dataLastItem;
        } else {
          img.classList.remove('opacity-100');
          img.classList.add('opacity-0');
        }
      });
      this.currentImage = this.lastImage ? 0 : this.currentImage + 1;
    }, this.intervalTime);
  }

  disconnectedCallback() {
    clearInterval(this.intervalId);
  }
}

if (!customElements.get('full-width-image')) {
  customElements.define('full-width-image', FullWidthImage);
}
